<div class="logindiv">
  <h2 class="register-header">Register</h2>

  <form [formGroup]="registerForm" #formDir="ngForm" (ngSubmit)="onSubmit()" class="register-form">
    <div [hidden]="formDir.submitted">
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput 
               placeholder="Email" 
               id="email" 
               formControlName="email" 
               name="email" 
               required 
               [(ngModel)]="form.email" 
               (change)="validateEmail()"
               autocomplete="email">
        
        <mat-error *ngIf="email.invalid && (email.dirty || email.touched)">
          <span *ngIf="email.errors?.['required']">Email is required.</span>
          <span *ngIf="email.errors?.['pattern']">Please provide a valid email address.</span>
        </mat-error>
        <mat-error *ngIf="emailNotUnique">Email not unique</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput 
               [type]="hide ? 'password' : 'text'" 
               placeholder="Password" 
               id="password" 
               formControlName="password" 
               name="password" 
               required 
               [(ngModel)]="form.password"
               autocomplete="new-password">
        
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide">
          <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>

        <mat-error *ngIf="password.invalid && (password.dirty || password.touched)">
          <span *ngIf="password.errors?.['required']">Password is required.</span>
          <span *ngIf="password.errors?.['minlength']">Password must be at least 6 characters long.</span>
        </mat-error>
      </mat-form-field>

      <div class="terms-row">
        <mat-checkbox formControlName="agreeToTerms" color="primary" required>
          I agree to the 
          <a href="/terms" target="_blank" (click)="$event.stopPropagation()">Terms & Conditions</a> 
          and have read the 
          <a href="/privacy" target="_blank" (click)="$event.stopPropagation()">Privacy Policy</a>.
        </mat-checkbox>
        <mat-error *ngIf="registerForm.get('agreeToTerms')?.invalid && registerForm.get('agreeToTerms')?.touched" class="custom-error-text">
          You must accept the terms to continue.
        </mat-error>
      </div>
      
      <div class="action-row">
        <button mat-raised-button color="primary" [disabled]="registerForm.invalid">
          Submit
        </button>
      </div>

    </div>
  </form>

  <div class="submitted-message-container" *ngIf="formDir.submitted">
    <div class="success-box" *ngIf="!isSignUpFailed">
      <p>Your registration is successful, enjoy using YourNotes</p>
    </div>
    
    <div class="error-box" *ngIf="isSignUpFailed">
      <p>{{errorMessage}}</p>
    </div>
  </div>
</div>